import axios, { ResponseType } from '~/api/axios';
import { PaymentService, PaymentServicesResponse } from '~/types';

export interface ServicesParams {
  next?: string;
  limit?: string;
}

export const getServices = (params: ServicesParams): ResponseType<PaymentServicesResponse> => {
  return axios.get('/payments/services', { params });
};

export const getServiceById = (id: string): ResponseType<PaymentService> => {
  return axios.get(`/payments/services/${id}`);
};
